import React, { useContext, useEffect, useState } from "react";
import { Badge, Button, Form, Table } from "react-bootstrap";
import {
  FaCarSide,
  FaHandsHelping,
  FaRedoAlt,
  FaSearch,
  FaUserCheck,
  FaUsers,
} from "react-icons/fa";
import { GlobalContext } from "../../Context/GlobalState";
import { billpunchbasicauth } from "../../utils/Credentials";
import { BASE_URL_API_TRANXT_UAT_API } from "../../utils/Constant";

const Packkyemployeedetails = () => {
  const [employeeData, setEmployeeData] = useState([]);
  const [userType, setUserType] = useState("0");
  const [searchTerm, setSearchTerm] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const { setTransactionLoaderState } = useContext(GlobalContext);
  const { username, password } = billpunchbasicauth;

  const userTypeOptions = [
    { label: "All", value: "0" },
    { label: "Driver", value: "1" },
    { label: "Volunteer", value: "2" },
  ];

  const formatDate = (dateValue) => {
    if (!dateValue) return "-";
    return dateValue.split("T")[0] || "-";
  };

  const getStatusBadge = (status) => {
    if (status === "Y") {
      return (
        <Badge bg="success" style={{ borderRadius: "999px", padding: "6px 10px" }}>
          Active
        </Badge>
      );
    }
    return (
      <Badge bg="secondary" style={{ borderRadius: "999px", padding: "6px 10px" }}>
        Inactive
      </Badge>
    );
  };

  const getFullName = (item) =>
    item.first_name || item.last_name
      ? `${item.first_name || ""} ${item.last_name || ""}`.trim()
      : item.username || "-";

  const filteredEmployeeData = employeeData.filter((item) => {
    const searchText = `${getFullName(item)} ${item.user_type || ""} ${
      item.phone_number || ""
    } ${item.email || ""} ${item.code || ""}`.toLowerCase();
    return searchText.includes(searchTerm.toLowerCase());
  });

  const driverCount = employeeData.filter((item) => item.user_type === "driver").length;
  const volunteerCount = employeeData.filter(
    (item) => item.user_type === "volunteer"
  ).length;
  const onDutyCount = employeeData.filter((item) => item.on_duty === 1).length;

  const fetchPackkyEmployees = async (selectedUserType = userType) => {
    setTransactionLoaderState(true);
    setErrorMessage("");

    try {
      const base64Credentials = btoa(`${username}:${password}`);
      const requestOptions = {
        method: "POST",
        headers: {
          Authorization: `Basic ${base64Credentials}`,
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          user_type: Number(selectedUserType),
          status: "Y",
        }),
        redirect: "follow",
      };

      const res = await fetch(
        `${BASE_URL_API_TRANXT_UAT_API}/api/SuperAdmin/v1.0/GetPackkyVolunteerByUserType`,
        requestOptions
      );
      const data = await res.json();

      if (data.responseCode === "00" && Array.isArray(data.response)) {
        setEmployeeData(data.response);
      } else {
        setEmployeeData([]);
        setErrorMessage(data.responseMessage || "Failed to fetch employee data");
      }
    } catch (error) {
      console.log("error", error);
      setEmployeeData([]);
      setErrorMessage("Something went wrong while fetching employee data");
    } finally {
      setTransactionLoaderState(false);
    }
  };

  const handleUserTypeChange = (value) => {
    setUserType(value);
    fetchPackkyEmployees(value);
  };

  useEffect(() => {
    fetchPackkyEmployees("0");
  }, []);

  return (
    <>
      <div
      >
        <div className="d-flex justify-content-between align-items-start mb-3 flex-wrap">
          <div>
            <h5 className="mb-1" style={{ color: "#24313f", fontWeight: 700 }}>
              Packky Employee Details
            </h5>
         
          </div>
          <Button
            size="sm"
            variant="light"
            onClick={() => fetchPackkyEmployees()}
            style={{
              border: "1px solid #cddfdc",
              borderRadius: ".5rem",
              color: "#0f766e",
              fontWeight: 600,
              background: "#f0fdfa",
            }}
          >
            <FaRedoAlt className="mr-1" /> Refresh
          </Button>
        </div>

        <div className="row">
          <div className="col-md-4 mb-2">
            <div
              className="p-3 h-100"
              style={{
                background: "#ffffff",
                border: "1px solid #e7d9c7",
                borderTop: "4px solid #4f46e5",
                borderRadius: ".75rem",
                boxShadow: "0 10px 24px rgba(36, 49, 63, 0.06)",
              }}
            >
              <div className="d-flex justify-content-between align-items-start">
                <div>
                  <div className="text-muted" style={{ fontSize: ".78rem", fontWeight: 600 }}>
                    Total Records
                  </div>
                  <h4 className="mb-0 mt-1" style={{ fontWeight: 800, color: "#24313f" }}>
                    {employeeData.length}
                  </h4>
                </div>
                <div
                  className="d-flex align-items-center justify-content-center"
                  style={{
                    width: "46px",
                    height: "46px",
                    borderRadius: "50%",
                    background: "#eef2ff",
                    color: "#4f46e5",
                    fontSize: "1.15rem",
                  }}
                >
                  <FaUsers />
                </div>
              </div>
              <div className="mt-3" style={{ height: "5px", borderRadius: "999px", background: "#eef2ff" }}>
                <div
                  style={{
                    width: "100%",
                    height: "5px",
                    borderRadius: "999px",
                    background: "#4f46e5",
                  }}
                />
              </div>
            </div>
          </div>
          <div className="col-md-4 mb-2">
            <div
              className="p-3 h-100"
              style={{
                background: "#ffffff",
                border: "1px solid #e7d9c7",
                borderTop: "4px solid #059669",
                borderRadius: ".75rem",
                boxShadow: "0 10px 24px rgba(36, 49, 63, 0.06)",
              }}
            >
              <div className="d-flex justify-content-between align-items-start">
                <div>
                  <div className="text-muted" style={{ fontSize: ".78rem", fontWeight: 600 }}>
                    On Duty
                  </div>
                  <h4 className="mb-0 mt-1" style={{ fontWeight: 800, color: "#24313f" }}>
                    {onDutyCount}
                  </h4>
                </div>
                <div
                  className="d-flex align-items-center justify-content-center"
                  style={{
                    width: "46px",
                    height: "46px",
                    borderRadius: "50%",
                    background: "#ecfdf5",
                    color: "#059669",
                    fontSize: "1.15rem",
                  }}
                >
                  <FaUserCheck />
                </div>
              </div>
              <div className="mt-3" style={{ height: "5px", borderRadius: "999px", background: "#d1fae5" }}>
                <div
                  style={{
                    width:
                      employeeData.length > 0
                        ? `${Math.min((onDutyCount / employeeData.length) * 100, 100)}%`
                        : "0%",
                    height: "5px",
                    borderRadius: "999px",
                    background: "#059669",
                  }}
                />
              </div>
            </div>
          </div>
          <div className="col-md-4 mb-2">
            <div
              className="p-3 h-100"
              style={{
                background: "#ffffff",
                border: "1px solid #e7d9c7",
                borderTop: "4px solid #d97706",
                borderRadius: ".75rem",
                boxShadow: "0 10px 24px rgba(36, 49, 63, 0.06)",
              }}
            >
              <div className="d-flex justify-content-between align-items-start">
                <div>
                  <div className="text-muted" style={{ fontSize: ".78rem", fontWeight: 600 }}>
                    Driver / Volunteer
                  </div>
                  <h4 className="mb-0 mt-1" style={{ fontWeight: 800, color: "#24313f" }}>
                    {driverCount} / {volunteerCount}
                  </h4>
                </div>
                <div
                  className="d-flex align-items-center justify-content-center"
                  style={{
                    width: "46px",
                    height: "46px",
                    borderRadius: "50%",
                    background: "#fff7ed",
                    color: "#d97706",
                    fontSize: "1.15rem",
                  }}
                >
                  <FaHandsHelping />
                </div>
              </div>
              <div className="d-flex mt-3" style={{ gap: ".5rem" }}>
                <div
                  className="d-flex align-items-center px-2 py-1"
                  style={{
                    gap: ".35rem",
                    borderRadius: "999px",
                    background: "#eef2ff",
                    color: "#4f46e5",
                    fontSize: ".78rem",
                    fontWeight: 700,
                  }}
                >
                  <FaCarSide /> {driverCount} Drivers
                </div>
                <div
                  className="d-flex align-items-center px-2 py-1"
                  style={{
                    gap: ".35rem",
                    borderRadius: "999px",
                    background: "#fff7ed",
                    color: "#d97706",
                    fontSize: ".78rem",
                    fontWeight: 700,
                  }}
                >
                  <FaHandsHelping /> {volunteerCount} Volunteers
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          className="d-flex justify-content-between align-items-center mb-3 flex-wrap"
          style={{ gap: ".75rem" }}
        >
          <div className="d-flex" style={{ gap: ".35rem" }}>
            {userTypeOptions.map((option) => {
              const active = userType === option.value;
              return (
                <Button
                  key={option.value}
                  size="sm"
                  variant="light"
                  onClick={() => handleUserTypeChange(option.value)}
                  style={{
                    borderRadius: "999px",
                    border: active ? "1px solid #0f766e" : "1px solid #d8cec0",
                    background: active ? "#0f766e" : "#ffffff",
                    color: active ? "#ffffff" : "#475467",
                    fontWeight: 600,
                    minWidth: "6rem",
                  }}
                >
                  {option.label}
                </Button>
              );
            })}
          </div>

          <div className="position-relative" style={{ width: "min(100%, 18rem)" }}>
            <FaSearch
              style={{
                position: "absolute",
                left: ".75rem",
                top: "50%",
                transform: "translateY(-50%)",
                color: "#9a8f80",
                fontSize: ".85rem",
              }}
            />
            <Form.Control
              size="sm"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              placeholder="Search name, mobile, email"
              style={{
                borderRadius: "999px",
                border: "1px solid #d8cec0",
                paddingLeft: "2rem",
                height: "2.15rem",
                background: "#ffffff",
              }}
            />
          </div>
        </div>

        {errorMessage && (
          <div className="alert alert-danger py-2" style={{ fontSize: ".9rem" }}>
            {errorMessage}
          </div>
        )}

        <div
          style={{
            background: "#ffffff",
            border: "1px solid #eee3d3",
            borderRadius: ".65rem",
            overflow: "hidden",
          }}
        >
          <Table hover responsive size="sm" className="mb-0">
            <thead>
              <tr style={{ background: "#f6f0e8" }}>
                <th className="text-center" style={{ border: "none", color: "#5f5347" }}>
                  #
                </th>
                <th style={{ border: "none", color: "#5f5347" }}>Employee</th>
                <th className="text-center" style={{ border: "none", color: "#5f5347" }}>
                  User Type
                </th>
                <th className="text-center" style={{ border: "none", color: "#5f5347" }}>
                  Contact
                </th>
                <th className="text-center" style={{ border: "none", color: "#5f5347" }}>
                  Duty
                </th>
                <th className="text-center" style={{ border: "none", color: "#5f5347" }}>
                  Shift
                </th>
                <th className="text-center" style={{ border: "none", color: "#5f5347" }}>
                  Type
                </th>
                <th className="text-center" style={{ border: "none", color: "#5f5347" }}>
                  Created On
                </th>
                <th className="text-center" style={{ border: "none", color: "#5f5347" }}>
                  Status
                </th>
              </tr>
            </thead>
            <tbody>
              {filteredEmployeeData.length > 0 ? (
                filteredEmployeeData.map((item, index) => (
                  <tr key={item.pk_id || item.id || index}>
                    <td className="text-center align-middle">{index + 1}</td>
                    <td className="align-middle">
                      <div className="d-flex align-items-center">
                        <div
                          className="d-flex align-items-center justify-content-center mr-2"
                          style={{
                            width: "36px",
                            height: "36px",
                            borderRadius: "50%",
                            background: "#ccfbf1",
                            color: "#0f766e",
                            fontWeight: 700,
                          }}
                        >
                          {getFullName(item).charAt(0).toUpperCase()}
                        </div>
                        <div>
                          <div className="px-2" style={{ fontWeight: 700, color: "#24313f", fontSize:".9rem" }}>
                            {getFullName(item)}
                          </div>
                         
                        </div>
                      </div>
                    </td>
                    <td className="text-center align-middle text-capitalize">
                      <Badge
                        bg={item.user_type === "driver" ? "info" : "dark"}
                        style={{
                          borderRadius: "999px",
                          padding: "6px 10px", fontSize:".9rem" ,
                          background:
                            item.user_type === "driver" ? "#4f46e5" : "#7c2d12",
                        }}
                      >
                        {item.user_type || "-"}
                      </Badge>
                    </td>
                    <td className="text-center align-middle">
                      <div style={{ fontWeight: 600 , fontSize:".9rem"  }}>{item.phone_number || "-"}</div>
                      <span className="text-muted" style={{ fontSize: ".8rem" }}>
                        {item.email || "-"}
                      </span>
                    </td>
                    <td className="text-center align-middle" style={{ fontSize:".9rem" }}>
                      {item.on_duty === 1 ? (
                        <Badge
                          bg="success"
                          style={{ borderRadius: "999px", padding: "6px 10px", fontSize:".9rem"  }}
                        >
                          On Duty
                        </Badge>
                      ) : (
                        <Badge
                          bg="warning"
                          text="dark"
                          style={{ borderRadius: "999px", padding: "6px 10px", fontSize:".9rem"  }}
                        >
                          Off Duty
                        </Badge>
                      )}
                    </td>
                    <td className="text-center align-middle" style={{ fontSize:".9rem" }}>
                      {item.shift_start || "-"} - {item.shift_end || "-"}
                    </td>
                    <td className="text-center align-middle text-capitalize" style={{ fontSize:".9rem" }}>
                      {item.type ? item.type.replace("_", " ") : "-"}
                    </td>
                    <td className="text-center align-middle" style={{ fontSize:".9rem" }}>
                      {formatDate(item.created_on)}
                    </td>
                    <td className="text-center align-middle" style={{ fontSize:".9rem" }}>
                      {getStatusBadge(item.status)}
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="9" className="text-center py-4 text-muted">
                    No Packky employee data found
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </div>
      </div>
    </>
  );
};

export default Packkyemployeedetails;
